import React from 'react';
import PropTypes from 'prop-types';

const Modal = props => {
	return (
		<div className={`modal ${props.active ? 'active' : ''}`}>
			<div className="modal-overlay"></div>
			<div className="modal-scrollable">
				<div className="vertical-center">
					<div className="modal-inner">
						<div
							className="modal-close-btn modal-close-trigger"
							onClick={props.onClose}
						>
							<span className="icon icon-cross"></span>
						</div>
						<div className="modal-content">{props.children}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

Modal.propTypes = {
	active: PropTypes.bool,
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func
};

Modal.defaultProps = {
	active: false,
	onClose: () => {}
};

export default Modal;
